import axios from "axios";

class BranchService {
    getBranches() {
        return axios.get('/branch/get')
    }
    getBranch(id) {
        return axios.get(`/branch/get/${id}`)
    }
    addBranch({name, code, inn, roaming_branch}) {
        return axios.post('/branch/register', {
            name: name,
            code: code,
            inn: inn,
            roaming_branch: roaming_branch,
        });
    }
    getBranchUse() {
        return axios.get('/branch-use/get')
    }
    edit(id, {
        name,
        code,
        roaming_branch,
    }) {
        return axios.post(`/branch/edit/${id}`, {
            name: name,
            code: code,
            roaming_branch: roaming_branch,
        })
    }

    deleteBranch({id}) {
        return axios.post(`/branch/delete/${id}`)
    }

    bindWarehouse(params) {
        return axios.post('/branch/warehouse/bind', params)
    }
}

const branchService = new BranchService();

export default branchService;
